import { useCallback, useMemo } from 'react';

import dedent from 'dedent-js';
import { useClient } from 'urql';
import { fromPromise } from 'xstate';

import { getGraphQLEndpoint } from '../../../Urql';
import { GetSessionDocument } from '../../graphql/session.generated';

import type { GetSessionQuery } from '../../graphql/session.generated';
import type { SessionData } from '../../setup';
import type { CombinedError } from 'urql';

// ─────────────────────────────────────────────────────────────────────────────

export const useFetchSessionActor = () => {
  const client = useClient();

  const fetchSession = useCallback(async (): Promise<SessionData> => {
    const response = await client
      .query<GetSessionQuery>(GetSessionDocument, {}, { requestPolicy: 'network-only' })
      .toPromise();
    const session = response.data?.session;

    if (response.error || !session) {
      throw generateSessionError(response.error);
    }

    return {
      isLoggedIn: session.isLoggedIn,
    };
  }, [client]);

  return useMemo(() => {
    return fromPromise<SessionData>(async () => fetchSession());
  }, [fetchSession]);
};

// ─── Helpers ─────────────────────────────────────────────────────────────────

function generateSessionError(error: CombinedError | undefined) {
  return new Error(dedent`
    - Network Error for Session Request - ${getGraphQLEndpoint()}
    ${error?.message}
    ${error?.networkError?.message}
    ${error?.graphQLErrors?.[0]?.message}
  `);
}
